module.exports = __webpack_public_path__ + "static/media/cert_150.4701d485.jpg";